$(document).ready(function(){
  
  /*ss14 slideshow*/
  var ss14List = 1;
  
  function ss14Right(){
    if(ss14List<12){
      ss14List++;
      $(".lookbookimg").css('background-image', 'url(http://cdn.shopify.com/s/files/1/0433/3957/files/ss'+ss14List+'.jpg?9983)');
      $("#lbpreview").attr('src', 'http://cdn.shopify.com/s/files/1/0433/3957/files/ss'+ss14List+'.jpg?9983');
      $("#listnumber").text(ss14List);
      $("#btnPrev").css("opacity","1");
	}
    if(ss14List==12){
      $("#btnNext").css("opacity","0.3");
    }
  }
  $("#btnNext").click(function(){
    ss14Right();
  });
  
  function ss14Left(){
    if(ss14List>1){
      ss14List--;
      $(".lookbookimg").css('background-image', 'url(http://cdn.shopify.com/s/files/1/0433/3957/files/ss'+ss14List+'.jpg?9983)');
      $("#lbpreview").attr('src', 'http://cdn.shopify.com/s/files/1/0433/3957/files/ss'+ss14List+'.jpg?9983');
      $("#listnumber").text(ss14List);
      $("#btnNext").css("opacity","1");
	}
    if(ss14List==1){
      $("#btnPrev").css("opacity","0.3");
    }
  }
  $("#btnPrev").click(function(){
    ss14Left();
  });
  /*end ss14 slideshow*/
  

  /*aw14 slideshow*/
  var aw14List = 1;
  
  function aw14Right(){
    if(aw14List<9){
      aw14List++;
      $(".lookbookimg2").css('background-image', 'url(https://cdn.shopify.com/s/files/1/0433/3957/files/aw'+aw14List+'.jpg?11486)');
      $("#lbpreview").attr('src', 'https://cdn.shopify.com/s/files/1/0433/3957/files/aw'+aw14List+'.jpg?11486');
      $("#listnumber").text(aw14List);
      $("#btnPrev2").css("opacity","1");
	}
    if(aw14List==9){
      $("#btnNext2").css("opacity","0.3");
    }
  }
  $("#btnNext2").click(function(){
    aw14Right();
  });
  
  function aw14Left(){
    if(aw14List>1){
      aw14List--;
      $(".lookbookimg2").css('background-image', 'url(https://cdn.shopify.com/s/files/1/0433/3957/files/aw'+aw14List+'.jpg?11486)');
      $("#lbpreview").attr('src', 'https://cdn.shopify.com/s/files/1/0433/3957/files/aw'+aw14List+'.jpg?11486');
      $("#listnumber").text(aw14List);
      $("#btnNext2").css("opacity","1");
	}
    if(aw14List==1){
      $("#btnPrev2").css("opacity","0.3");
    }
  }
  $("#btnPrev2").click(function(){
    aw14Left();
  });
  /*end aw14 slideshow*/
  
  
  
  
  
  
  
  
});